import store from '@/store';

import { TabType } from '../store/chatTab.store';
import ChatQueries from '../queries/chat.queries';
import UtilsService from './UtilsService';
import ApiService from './ApiService';
import { SubscribeQuery } from '../queries';

async function getChatsByTab(tab: { type: TabType, entityId?: string }) {
  const query: SubscribeQuery = getQuery(tab) as SubscribeQuery;
  if (!query) { return; }
  return ApiService.get(UtilsService.buildFullPath(query)).then((res) => res.results);
}

async function getChatById(chatId: string) {
  const query: any = ChatQueries.getById(chatId);
  const chat = await ApiService.get(UtilsService.buildFullPath(query));
  return chat.results.length && chat.results[0] || null;
}

async function getChatByChatId(chatId: string) {
  const query: any = ChatQueries.getByChatId(chatId);
  const chat = await ApiService.get(UtilsService.buildFullPath(query));
  return chat.results.length && chat.results[0] || null;
}

function getQuery(tab: { type: TabType, entityId?: string }) {
  const retailerId = store.state.auth.currentUser.retailer.objectId;
  const currentUserId = store.state.auth.currentUser.objectId;
  if (tab.type === TabType.RUNNING) {
    return ChatQueries.getAllRunning(retailerId, currentUserId);
  } else if (tab.type === TabType.FISINHED) {
    return ChatQueries.getAllFinished(retailerId);
  } else if (tab.type === TabType.WAITING) {
    return ChatQueries.getAllWaiting(retailerId);
  } else if (tab.type === TabType.ALL) {
    return ChatQueries.getAll(retailerId);
  } else if (tab.type === TabType.TEAM) {
    return ChatQueries.getAllByTeam(retailerId, tab.entityId as string);
  } else if (tab.type === TabType.USER) {
    return ChatQueries.getAllByUser(retailerId, tab.entityId as string);
  }
}

const ChatService = {
  getChatsByTab,
  getQuery,
  getChatById,
  getChatByChatId,
};

export default ChatService;
